import Vue from 'vue'
import vuetify from './plugins/vuetify'
import VuetifyDialog from 'vuetify-dialog'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import config from '@/config'
import constants from '@/constants'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/filters'
import AmapVue from '@amap/amap-vue'
import VueDateRangePicker from 'vuetify-daterange-picker'
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css'
import VueDatetimePicker from 'vuetify-datetime-picker'
// import 'vuetify-datetime-picker/src/stylus/main.styl'
import has from '@/utils/btnPermissions.js'
import JsonExcel from 'vue-json-excel'
import VueAreaLinkage from 'vue-area-linkage'
import 'vue-area-linkage/dist/index.css'
import VCharts from 'v-charts'
import vueEsign from 'vue-esign'
import i18n from './i18n'
import array from './plugins/array'
import store from './store'
import router from './router'
import App from './App.vue'
import func from './plugins/preload.js'
import { isMobile } from './utils/tool.js'
import '@/assets/iconfont/iconfont.js'

Vue.use(vueEsign)
Vue.use(VueDateRangePicker)
Vue.use(VueDatetimePicker)
Vue.component('downloadExcel', JsonExcel)
Vue.use(VueAreaLinkage)
Vue.use(VCharts)
Vue.use(array)
Vue.use(VuetifyDialog, {
    context: {
      vuetify
    }
})
Vue.use(has)
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
Vue.prototype.$constants = constants
Vue.prototype.$func = func
Vue.prototype.$isMobile = isMobile()
// map
AmapVue.config.version = '2.0'
AmapVue.config.key = 'a545bf5e1cbb4cfeb67f5783c4f8e0e0';
AmapVue.config.plugin = [
    'AMap.MoveAnimation',
    'AMap.ToolBar'
  ]
Vue.use(AmapVue)
Vue.directive('focus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function(el) {
        el.focus()
    }
});

const vue = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
export default vue
